import { Component } from '@angular/core';

@Component({
  templateUrl: './main-root.html',
  selector: 'main-root'
})
export class MainRootComponent {
}



// WEBPACK FOOTER //
// ./src/app/main/components/main-root.component.ts